import React from "react";
import bgImg from "../../assets/images/bgImg.png";
const Loader: React.FC = () => {
  return (
    <div className="loader-container" >
    <div className="fading-bars"  >
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
    </div>
</div>
  );
};

export default Loader;
